export const memoryFinalText = (
  <>
    <p>
      O objetivo do <strong>Memory Lab</strong> vai além da pontuação. A ideia é ajudar você a desenvolver <strong>autoconhecimento cognitivo</strong>, entendendo como sua memória funciona na prática.
    </p>

    <p>
      Ao longo do tempo, você pode acompanhar sua evolução, comparar resultados e identificar quais tipos de memória são mais fortes — e quais precisam de mais treino.
    </p>

    <ul>
      <li>📊 Acompanhe seu desempenho</li>
      <li>🧠 Descubra seu tipo de memória dominante</li>
      <li>🚀 Melhore sua performance com prática contínua</li>
    </ul>

    <p>
      Esse tipo de treino estimula habilidades essenciais como foco, atenção e memória operacional, de forma leve, interativa e acessível no dia a dia.
    </p>
  </>
);